import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  contentWrapper: theme => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing.sm};
    margin-top: ${theme.spacing.sm};
    margin-bottom: ${theme.spacing.sm};

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      margin-top: ${theme.spacing.xs};
      margin-bottom: ${theme.spacing.xs};
    }
  `,
})

export { useStyles }
